export const PermissionKey_SearchV1Viewer = 'permission-key--search-v1-viewer';
export const PermissionKey_SearchV1NoViewer = 'permission-key--search-v1-no-viewer';
export const PermissionKey_SearchV2Viewer = 'permission-key--search-v2-viewer';
export const PermissionKey_SearchV2NoViewer = 'permission-key--search-v2-no-viewer';
//# sourceMappingURL=permission-keys.js.map